import React from 'react';
import { Box } from '@mui/material';

interface GuidanceTourSpotlightProps {
  targetRect: DOMRect | null;
}

const GuidanceTourSpotlight: React.FC<GuidanceTourSpotlightProps> = ({
  targetRect,
}) => {
  if (!targetRect) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: targetRect.top,
        left: targetRect.left,
        width: targetRect.width,
        height: targetRect.height,
        borderRadius: 1,
        outline: '2px solid rgba(25, 118, 210, 0.85)',
        boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.45)',
        zIndex: 1300,
        pointerEvents: 'none',
        transition:
          'top 0.2s ease, left 0.2s ease, width 0.2s ease, height 0.2s ease',
        animation: 'guidanceTourPulse 2s ease-in-out infinite',
        '@keyframes guidanceTourPulse': {
          '0%, 100%': { outlineColor: 'rgba(25, 118, 210, 0.85)' },
          '50%': { outlineColor: 'rgba(25, 118, 210, 0.45)' },
        },
      }}
    />
  );
};

export default GuidanceTourSpotlight;
